module.exports = __webpack_public_path__ + "static/media/PP-HERO-HOLTEKAMP.fed5e770.png";